export default {
    locale: 'da-DK',
    dismissAlertText: 'Luk'
};
